export  default {
    getPermOperators(state) {
        return state.permOperators;
    },
    getPermOperatorsByGroup(state, id) {
        return state.permOperators.find(x => x.groupId === id);
    },
};